// extracted by mini-css-extract-plugin
export default {"footer":"FS6Y7ygTH8swHvFOVmCg","line":"nBZ5NPrwbtT8g0MTFBzX"};